import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {
  getConfiguredProcedureProductLimit,
  ProcedureProductLimitsConfigKey,
} from 'procedures/design/ProcedureDesignConstants';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';

export default function getMaterialValueCountLimitError(typedValue: TypedValue | null): string | null {
  const limit = getConfiguredProcedureProductLimit(ProcedureProductLimitsConfigKey.MAX_PARAMETER_VALUES);
  if (
    limit == null ||
    typedValue?.type !== FieldType.BIOENTITY_LINK ||
    typedValue.targetFiles.length <= limit
  ) {
    return null;
  }
  return `Material value contains ${typedValue.targetFiles.length} materials; maximum is ${limit}.`;
}
